<span class="text-nowrap">{{ text() }}</span>
